// EmailJS Configuration
// To set up EmailJS:
// 1. Go to https://www.emailjs.com/
// 2. Create an account
// 3. Create a service (Gmail, Outlook, etc.)
// 4. Create email templates
// 5. Replace the values below with your actual keys

export const emailConfig = {
  publicKey: 'gNsgz3pnVNp3fjXVy', // Your EmailJS public key
  serviceId: 'service_gut8ejd', // Your EmailJS service ID
  contactTemplateId: 'template_10p0hhp', // Template for contact form
  searchTemplateId: 'template_10p0hhp' // Template for property search (same template)
};

// Example template for Contact Form (create this in EmailJS dashboard):
/*
Subject: New Contact Form Submission - {{subject}}

From: {{from_name}} <{{from_email}}>
Subject: {{subject}}

Message:
{{message}}

Reply to: {{reply_to}}
*/

// Example template for Property Search (create this in EmailJS dashboard):
/*
Subject: New Property Search Request

New property search request from website:

Location: {{location}}
Property Type: {{property_type}}
Price Range: {{min_price}} - {{max_price}}
Bedrooms: {{bedrooms}}
Bathrooms: {{bathrooms}}

{{message}}

This is an automated message from your real estate website.
*/